<template>
  <router-view />
</template>

<script>
/** @class App */
export default {};
</script>

<style lang="scss">
@import '../sass/app';
</style>
